// extracted by mini-css-extract-plugin
export default {"close":"close___ucYxH","header":"header___cbA_9","only-close":"only-close___E2dIt"};